import { computed, ref } from 'vue'

const DIACRITIC_REGEX = /\p{Diacritic}/gu

export function normalizeString(str: unknown, strict = true) {
  return strict
    ? String(str).toLowerCase().trim()
    : String(str).normalize('NFD').replace(DIACRITIC_REGEX, '').toLowerCase().trim()
}

export type SearchFilter = (val: string) => boolean

export default function useSearch() {
  const search = ref('')
  function clearSearch() {
    search.value = ''
  }
  const normalizedSearch = computed(() => normalizeString(search.value))
  function searchFilter(val: string) {
    return normalizeString(val).includes(normalizedSearch.value)
  }
  return { search, clearSearch, searchFilter }
}
